/** @jsx jsx */
import { jsx } from '@emotion/core'
import { styles } from './style'
import { useEffect, useState } from 'react'
import { getBanners } from '../././../../sources/slot-finder'

export default function DisplayArtworks(props) {
  const [artworks, setArtworks] = useState(null)
  const [inViewIndex, setInViewIndex] = useState(0)
  const [id, setId] = useState(null)

  useEffect(() => {
    (async function getBanner() {
      try {
        const resp = await getBanners()
        const { artworkImages = [] } = resp
        setArtworks(artworkImages)
      } catch (e) {
        console.log(e)
      }
    })()
  }, [])

  useEffect(() => {
    return () => {
      if (id) {
        clearInterval(id)
      }
    }
  }, [id])

  function scrollhandler(artworks) {
    artworks.forEach((element, index) => {
      if (isInViewport(document.getElementById(`artwork-${index}`))) {
        setInViewIndex(index)
      }
    })
  }

  function automaticScroll() {
    let element = 0
    let lengthOfScrollableElement = artworks.length || 1
    setId(setInterval(() => {
      element = Math.floor((1 + element) % lengthOfScrollableElement)
      const scrollableContainer = document.getElementById(`artwork-box`)
      scrollableContainer.scrollLeft = document.getElementById(`artwork-${element}`).offsetLeft - 8
    }, 3000))
  }

  return (
    <div css={styles.promoContainer}
    >
      <div
        css={{ ...styles.scrollmenu, scrollBehavior: artworks && inViewIndex == artworks.length - 1 ? 'auto' : 'smooth' }}
        id='artwork-box'
        onScroll={scrollhandler.bind(props, artworks)}
        onLoad={automaticScroll}
      >
        {artworks && artworks.map((artwork, index) => {
          return (
            <img
              key={`${index}-artwork`}
              id={`artwork-${index}`}
              src={artwork.imageUrl}
              css={styles.cardImg((index === artworks.length - 1))}
            />
          )
        })}
      </div>
    </div >
  )
}

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)

  );
}